<template>
  <div class="intern-notes-container">
    <button class="open-button" @click="isOpen = !isOpen">Interne noter <div class="dot" v-if="noteText.length > 1"></div></button>
    <div class="subs-note" :class="{'subs-note--is-open': isOpen}">
      <div class="subs-note__container">
        <div class="subs-note__container__header">
          <div class="subs-note__container__header__close" @click="isOpen = !isOpen">
            <span class="icon-cross2"></span>
          </div>
          <h2>Dagens interne noter</h2>
        </div>
        <div class="subs-note__container__body">
          <h3>Noter til {{showDate}}</h3>
          <div class="subs-note__container__note">
            <AppEIPWYZIWYG
              :textInput="noteText"
              @close="updateNoteText">
            </AppEIPWYZIWYG>
          </div>
        </div>
      </div>
    </div>
    <transition name="fadeIn">
      <div class="bg-overlay" v-if="isOpen" @click="isOpen = false"></div>
    </transition>
  </div>
</template>

<script>
  import AppEIPWYZIWYG from '../common/AppEIPWYZIWYG'
  import moment from 'moment'
  import docendo from '../../docendo'

  export default {
    components: {AppEIPWYZIWYG},
    props: {
      date: {}
    },
    data () {
      return {
        isOpen: false,
        noteText: ''
      }
    },
    watch: {
      date (val) {
        this.readNoteText()
      }
    },
    computed: {
      showDate () {
        return moment(this.date).locale(window.USER.locale).format('dddd DD. MMMM YYYY')
      },
      serverDate () {
        return moment(this.date).format('YYYY-MM-DD')
      }
    },
    methods: {
      readNoteText () {
        docendo.schoolSubstituteDayNoteRead(window.SCHOOL.id, this.serverDate, data => {
          this.noteText = data.note ? data.note : ''
        })
      },
      updateNoteText (updatedText) {
        docendo.schoolSubstituteDayNoteUpdate(window.SCHOOL.id, this.serverDate, updatedText.text,
          success => {
            this.noteText = success.note
          }, failure => {
            console.log('failed!')
          })
      }
    },
    mounted () {
      this.readNoteText()
    }
  }
</script>

<style>
  @import '../../assets/css/variables.css';

  .subs-note {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 10000;
    width: 25%;
    font-size: 12px !important;
    min-width: 350px;
    background: #f6f7f8;
    box-shadow: 0 0 14px rgba(0, 0, 0, 0.2);
    transform: translateX(100%);
    transition: transform 0.5s;
  }

  .subs-note.subs-note--is-open {
    transform: translateX(0);
  }

  .subs-note__opener {
    position: absolute;
    cursor: pointer;
    top: 50%;
    left: -92px;
    color: white;
    display: flex;
    align-items: center;
    height: 45px;
    border-radius: 4px 4px 0 0;
    padding: 10px;
    font-weight: bold;
    transform: rotate(-90deg);
    background-color: var(--blue);
    box-shadow: 0px -8px 11px -4px rgba(0, 0, 0, .2);
  }

  .open-button {
    display: flex;
    width: auto;
    margin-right: 1rem;
    align-items: center;
    height: 100%;
    white-space: nowrap;
  }

  .dot {
    background-color: #3ecf8e;
    border-radius: 50%;
    width: 10px;
    height: 10px;
    margin-left: 5px;
  }

  .subs-note__opener__icons {
    cursor: pointer;
    font-size: 20px;
    margin-left: 10px;
    margin-top: 2px;
  }

  .subs-note__container__header {
    position: relative;
    overflow: hidden;
    border-radius: 4px 4px 0 0;
    color: #3d4340;
    border-bottom: 1px solid #d8d8d8;
    text-align: center;
    margin-bottom: 20px;
    padding: 12px;
  }

  .subs-note__container__header > h2 {
    color: rgba(44, 62, 80, .8);
    text-transform: uppercase;
    font-size: 1.2rem;
  }

  .subs-note__container__header__close {
    position: absolute;
    top: 0;
    left: 0;
    padding: 1rem;
    cursor: pointer;
    font-size: 1.2rem;
  }

  .subs-note__container__body > h3 {
    margin: 0px 10px 10px 10px;
  }

  .subs-note__container__note {
    margin: 0 10px;
    border-radius: 4px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .07);
    background: #fff;
    border: 1px solid #d8d8d8;
  }

  .bg-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.25);
    z-index: 1000;
  }

</style>



// WEBPACK FOOTER //
// SubsNote.vue?0965847a